import React from "react";
import isEmail from "validator/lib/isEmail";
import Modal from "Components/smallModal/smallModal";
import Input from "Components/input/Input";
import Button from "Components/button/Button";
import PropTypes from "prop-types";
import withFormState from "Components/withFormState";
import PageTitle from "Components/pageTitle/PageTitle";
import request from "../../config";
import TranslatedString from "Components/TranslatedString";
import { alertError, alertSuccess } from "Utils/alerts";
import { t } from "i18next";
import cx from "classnames";
import s from "./resetPwdModal.scss";

const initialFormState = {
  identifier: "",
};

class ResetPwdModal extends React.Component {
  constructor(props) {
    super(props);
    this.resetAndClose = this.resetAndClose.bind(this);
    this.state = {
      passwordRecoveryDisabled: false,
    };
  }

  validate(data) {
    let errors = {};

    if (!data.identifier || !isEmail(data.identifier)) {
      errors.identifier = "email address is not a valid one";
    }
    return errors;
  }

  resetAndClose() {
    this.setState({ passwordRecoveryDisabled: false });
    this.props.setFormFieldValue({ identifier: null });
    this.props.handleClose();
  }

  handleResetPassword(e) {
    e.preventDefault();
    this.props.setFormLoading();
    const errors = this.validate(this.props.formData);
    if (Object.keys(errors).length > 0) {
      this.props.setFormErrors(errors);
      this.props.unsetFormLoading();
    } else {
      const config = {
        method: "POST",
        url: "/users/reset_password",
        data: this.props.formData,
      };
      request(config)
        .then(() => {
          this.props.unsetFormLoading();
          alertSuccess(t("alert.resetEmailSended"));
          this.props.handleClose();
        })
        .catch((e) => {
          // password recovery or password change is disabled on this account
          if (e.response && e.response.status === 403) {
            this.setState({ passwordRecoveryDisabled: true });
          }
          // treat this as success even if failed, to not give hints on the users present on the system
          alertSuccess(t("alert.resetEmailSended"));
          this.props.unsetFormLoading();
        });
    }
  }

  render() {
    const { opened, handleClose, formData, setFormFieldValue, formErrors, isFormLoading } = this.props;

    return (
      <Modal title={t("modal.recoveryPassword.title")} opened={opened} closeModal={handleClose} withForm>
        <form className={s.form} method="post" onSubmit={this.handleResetPassword.bind(this)}>
          <div className={s.wrapInputs}>
            {this.state.passwordRecoveryDisabled && (
              <div>
                <TranslatedString>modal.recoveryPassword.disabled</TranslatedString>
              </div>
            )}

            {!this.state.passwordRecoveryDisabled && (
              <div>
                <TranslatedString>modal.recoveryPassword.desc</TranslatedString>
              </div>
            )}

            {!this.state.passwordRecoveryDisabled && (
              <Input
                className={s.input}
                name="identifier"
                onChange={setFormFieldValue}
                value={formData.identifier}
                errors={formErrors.identifier}
                noLabel
                placeholder=" "
              />
            )}
          </div>
          <div className="flex items-center justify-end gap-2">
            <Button
              color={this.state.passwordRecoveryDisabled ? "outline" : "text"}
              type="button"
              onClick={this.resetAndClose}
            >
              {this.state.passwordRecoveryDisabled ? `button.close` : `button.cancel`}
            </Button>

            {!this.state.passwordRecoveryDisabled && (
              <Button id="login" type="submit" loading={isFormLoading}>
                button.passwordRecovery
              </Button>
            )}
          </div>
        </form>
      </Modal>
    );
  }
}

export default withFormState(ResetPwdModal, initialFormState);
